module.exports = __webpack_public_path__ + "plugins/web/img/std_qrcode.150788e4.png";